/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { GbcarApiConfiguration as __Configuration } from '../gbcar-api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { CredentialDto } from '../models/credential-dto';
import { CompanyLoginResponse } from '../models/company-login-response';
import { LimitedLoginResponseDto } from '../models/limited-login-response-dto';
import { LimitedLoginRequest } from '../models/limited-login-request';
@Injectable({
  providedIn: 'root',
})
class ExternalAuthenticationService extends __BaseService {
  static readonly postExternalAuthenticationLoginPath = '/ExternalAuthentication/Login';
  static readonly postExternalAuthenticationCompanyLoginPath = '/ExternalAuthentication/CompanyLogin';
  static readonly postExternalAuthenticationLimitedLoginPath = '/ExternalAuthentication/LimitedLogin';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param body undefined
   * @return Success
   */
  postExternalAuthenticationLoginResponse(body?: CredentialDto): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/ExternalAuthentication/Login`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * @param body undefined
   * @return Success
   */
  postExternalAuthenticationLogin(body?: CredentialDto): __Observable<string> {
    return this.postExternalAuthenticationLoginResponse(body).pipe(
      __map(_r => _r.body as string)
    );
  }

  /**
   * @param body undefined
   * @return Success
   */
  postExternalAuthenticationCompanyLoginResponse(body?: CredentialDto): __Observable<__StrictHttpResponse<CompanyLoginResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/ExternalAuthentication/CompanyLogin`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<CompanyLoginResponse>;
      })
    );
  }
  /**
   * @param body undefined
   * @return Success
   */
  postExternalAuthenticationCompanyLogin(body?: CredentialDto): __Observable<CompanyLoginResponse> {
    return this.postExternalAuthenticationCompanyLoginResponse(body).pipe(
      __map(_r => _r.body as CompanyLoginResponse)
    );
  }

  /**
   * @param body undefined
   * @return Success
   */
  postExternalAuthenticationLimitedLoginResponse(body?: LimitedLoginRequest): __Observable<__StrictHttpResponse<LimitedLoginResponseDto>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/ExternalAuthentication/LimitedLogin`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<LimitedLoginResponseDto>;
      })
    );
  }
  /**
   * @param body undefined
   * @return Success
   */
  postExternalAuthenticationLimitedLogin(body?: LimitedLoginRequest): __Observable<LimitedLoginResponseDto> {
    return this.postExternalAuthenticationLimitedLoginResponse(body).pipe(
      __map(_r => _r.body as LimitedLoginResponseDto)
    );
  }
}

module ExternalAuthenticationService {
}

export { ExternalAuthenticationService }
